import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'next-i18next';

import styles from './styles.module.scss';

const Title = (props) => {
    const { t, step, isInvestor } = props;
    let title;

    if (step === 3) {
        title = t('account-setup-title');
    } else {
        title = isInvestor ? t('investor-registration-title') : t('advisor-registration-title');
    }

    return <div className={styles.title}>{title}</div>;
};

Title.propTypes = {
    step: PropTypes.number.isRequired,
    isInvestor: PropTypes.bool.isRequired,
};

export default compose(withTranslation())(Title);
